import { memo } from 'react';

const GetStepContent = ({ step, children }) => {
  return children[step];
};

export default memo(GetStepContent);
